import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faBell } from '@fortawesome/pro-regular-svg-icons';
import CircleText from './CircleText';
const NotificationsIcon = _ref => {
  let {
    unreadActivityCount,
    unreadMessagesCount,
    size,
    iconColor
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faBell,
    color: iconColor
  }), !!unreadMessagesCount && CircleText(unreadMessagesCount, ''), !!unreadActivityCount && CircleText(unreadActivityCount, 'notifications'));
};
export default NotificationsIcon;
//# sourceMappingURL=NotificationsIcon.js.map